export const getUspDataEndpoint = (clientId: string, locale: string) => {
  const isFr = locale.includes('fr') ? 'fr' : 'de';
  return `https://storage.googleapis.com/drupal-pages/production/menus/${clientId.toLowerCase()}/${isFr}/bucket-usp-bar.json`;
};
